export { default as GDMPageCard } from './GDMPageCard';

export type { GDMPageCardProps, GDMPageCardComponent } from './GDMPageCard.type';
